export enum ActiveGameButtonType {
  TAKE_SEAT = 'TAKE_SEAT',
  UNREGISTER = 'UNREGISTER'
}

export interface ActiveGameData {
  id: string;
  title: string;
  type: string;
  state?: string;
  buttonType: ActiveGameButtonType;
}
